import domains from "./contractABI.json";

export const domainsAbi = domains.abi;
export const domainsAddress = "0x02328D1008AB24B643dB76763c058aE03bcCd66E";